import { domainEUUrl } from 'config';
import React, {useEffect} from 'react';
import { Route } from 'react-router-dom';
import { useModalService } from 'src/services/ModalService';
import { setRegisterTypeCookie } from "src/utils/auth";

// Modals
import SuccessModal from 'src/components/modals/Success';
import ErrorModal from 'src/components/modals/Error';
import {userMe} from "./api/authentication";

const _PublicRoute = ({
    component: Component,
   ...rest
}) => {
    const { modals } = useModalService();

    useEffect(() => {
        // No access allowed to URLs from the darwinex.eu domain
        if (domainEUUrl && domainEUUrl !== '' && document.location.href.includes(domainEUUrl)) {
            document.location.replace('/404');
        }
        setRegisterTypeCookie();
    }, []);

    return (
        <Route
            {...rest}
            render={
                (props) => (<>
                    <Component {...props} {...rest}  />
                    {(modals && modals.current === 'success') && <SuccessModal show/>}
                    {(modals && modals.current === 'error') && <ErrorModal show/>}
                </>)
            }
        />
    );
};

export const PublicRoute = _PublicRoute;
